import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  de: {
    // Navigation
    nav: {
      services: "Leistungen",
      kmuFulfillment: "KMU Fulfillment",
      about: "Über uns",
      blog: "Blog",
      contact: "Kontakt",
      requestQuote: "Jetzt Angebot anfordern",
      contactUs: "Kontaktieren Sie uns!",
    },
    // Hero
    hero: {
      title1: "Fulfillment & Versand",
      title2: "für Online-Händler",
      subtitle: "Same-Day Versand bis 12 Uhr • Fulfillment ab 20 Sendungen/Monat • Versand in 180 Länder",
      subtitleSmall: "Ihr persönlicher Ansprechpartner – alles aus einer Hand.",
      cta: "Kostenloses Angebot anfordern",
      // USP badges
      usps: {
        sameDay: "Same-Day bis 12 Uhr",
        countries: "180 Länder weltweit",
        fulfillment: "Ab 20 Sendungen/Monat",
        personal: "Persönlicher Ansprechpartner",
      },
    },
    // Services
    services: {
      title: "Unser Angebot",
      shipping: {
        title: "Verpackung & Versand",
        description: "Versandservice ab 5 Paketen/Monat. Wir erstellen Ihre Labels und organisieren die Abholung bei Ihnen vor Ort.",
      },
      express: {
        title: "Express & Luftfracht",
        description: "Same-Day Versand bis 12 Uhr. Expresslieferungen und Luftfracht in 180 Länder weltweit.",
      },
      fulfillment: {
        title: "Fulfillment & E-Commerce",
        description: "Fulfillment ab 20 Sendungen/Monat. Lagerhaltung, Kommissionierung und Versand – alles aus einer Hand.",
      },
      packaging: {
        title: "Verpackungsservice",
        description: "Professionelle Verpackungslösungen für empfindliche Waren, Kunst, Antiquitäten und Sondergrößen.",
      },
      learnMore: "Mehr erfahren",
    },
    // About section
    about: {
      title: "Kauz Logistik e.K.",
      subtitle: "Über uns",
      description1: "Die Kauz Logistik e.K. bietet Ihnen ein starkes Logistiknetzwerk mit modernen Lagermöglichkeiten und modernster Technik.",
      description2: "Mit unserem Unternehmen können wir Ihnen eine breite Palette an Logistikdienstleistungen anbieten, vom Fulfillment über Same Day/Next Day Lieferungen mit eigenem Fuhrpark bis hin zum Transportmanagement.",
      learnMore: "Mehr über uns",
    },
    // Stats
    stats: {
      title: "Kauz Logistik - Ein starker Partner",
      customers: "Zufriedene Kunden",
      experience: "Jahre Erfahrung",
      warehouse: "m² Lagerfläche",
      packages: "Pakete pro Jahr",
    },
    // CTA
    cta: {
      title: "Wir beraten Sie gerne",
      description: "Fordern Sie jetzt Ihr individuelles und unverbindliches Angebot an und starten Sie mit uns den Turbo für Ihr Business!",
      button: "Kontaktieren Sie uns!",
    },
    // Blog
    blog: {
      title: "Blogbeiträge",
      viewAll: "Alle Beiträge",
      readMore: "Mehr erfahren",
    },
    // Contact
    contact: {
      title: "Kontaktieren Sie uns",
      subtitle: "Wir freuen uns auf Ihre Nachricht und melden uns schnellstmöglich bei Ihnen.",
      reachUs: "So erreichen Sie uns",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      hours: "Geschäftszeiten",
      hoursValue: "Mo-Fr: 08:00 - 17:00 Uhr",
      companyData: "Firmendaten",
      writeUs: "Schreiben Sie uns",
      formDescription: "Füllen Sie das Formular aus und wir melden uns schnellstmöglich bei Ihnen.",
      name: "Name",
      company: "Unternehmen",
      message: "Nachricht",
      send: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Vielen Dank!",
      successMessage: "Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns schnellstmöglich bei Ihnen melden.",
      sendAnother: "Weitere Nachricht senden",
    },
    // Quote
    quote: {
      title: "Angebot anfordern",
      subtitle: "Fordern Sie jetzt Ihr individuelles und unverbindliches Angebot an.",
      ourServices: "Unsere Leistungen",
      selectService: "Wählen Sie die gewünschte Leistung und wir erstellen Ihnen ein maßgeschneidertes Angebot.",
      yourRequest: "Ihre Anfrage",
      formDescription: "Füllen Sie das Formular aus und wir erstellen Ihnen ein individuelles Angebot.",
      contactPerson: "Ansprechpartner",
      service: "Gewünschte Leistung",
      selectServicePlaceholder: "Leistung auswählen",
      volume: "Erwartetes Volumen",
      selectVolume: "Volumen auswählen",
      requirements: "Beschreibung Ihrer Anforderungen",
      requirementsPlaceholder: "Beschreiben Sie Ihre Anforderungen, z.B. Art der Waren, Liefergebiete, besondere Wünsche...",
      submit: "Angebot anfordern",
      benefits: "Ihre Vorteile",
      free: "Kostenlos & unverbindlich",
      fast: "Schnelle Rückmeldung",
      individual: "Individuelle Beratung",
      transparent: "Transparente Preise",
      success: "Vielen Dank für Ihre Anfrage!",
      successMessage: "Wir haben Ihre Angebotsanfrage erhalten und werden uns schnellstmöglich bei Ihnen melden.",
      responseTime: "In der Regel erhalten Sie innerhalb von 24 Stunden eine Rückmeldung.",
      sendAnother: "Weitere Anfrage stellen",
      combination: "Kombination mehrerer Leistungen",
    },
    // Footer
    footer: {
      description: "Ihr zuverlässiger Partner für Fulfillment, Transport und Verpackungsservice in Sulzbach und der gesamten Rhein-Main-Region.",
      quickLinks: "Schnellzugriff",
      home: "Startseite",
      servicesLink: "Leistungen",
      companyLink: "Unternehmen",
      blogLink: "Blog",
      contactLink: "Kontakt",
      servicesTitle: "Leistungen",
      contactTitle: "Kontakt",
      copyright: "Alle Rechte vorbehalten.",
      ceo: "Geschäftsführer",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    // Common
    common: {
      requestQuote: "Angebot anfordern",
      contactUs: "Kontakt aufnehmen",
      phone: "Telefon",
      email: "E-Mail",
    },
  },
  en: {
    // Navigation
    nav: {
      services: "Services",
      kmuFulfillment: "SME Fulfillment",
      about: "About Us",
      blog: "Blog",
      contact: "Contact",
      requestQuote: "Request a Quote",
      contactUs: "Contact Us!",
    },
    // Hero
    hero: {
      title1: "Fulfillment & Shipping",
      title2: "for Online Retailers",
      subtitle: "Same-Day Shipping until 12 PM • Fulfillment from 20 shipments/month • Shipping to 180 countries",
      subtitleSmall: "Your personal contact – everything from one source.",
      cta: "Get Free Quote",
      // USP badges
      usps: {
        sameDay: "Same-Day until 12 PM",
        countries: "180 countries worldwide",
        fulfillment: "From 20 shipments/month",
        personal: "Personal contact person",
      },
    },
    // Services
    services: {
      title: "Our Services",
      shipping: {
        title: "Packaging & Shipping",
        description: "Shipping service from 5 packages/month. We create your labels and organize pickup at your location.",
      },
      express: {
        title: "Express & Air Freight",
        description: "Same-day shipping until 12 PM. Express deliveries and air freight to 180 countries worldwide.",
      },
      fulfillment: {
        title: "Fulfillment & E-Commerce",
        description: "Fulfillment from 20 shipments/month. Warehousing, picking and shipping – all from one source.",
      },
      packaging: {
        title: "Packaging Service",
        description: "Professional packaging solutions for fragile goods, art, antiques and custom sizes.",
      },
      learnMore: "Learn more",
    },
    // About section
    about: {
      title: "Kauz Logistik e.K.",
      subtitle: "About Us",
      description1: "Kauz Logistik e.K. offers you a strong logistics network with modern storage facilities and state-of-the-art technology.",
      description2: "With our company, we can offer you a wide range of logistics services, from fulfillment to same day/next day deliveries with our own fleet to transport management.",
      learnMore: "More about us",
    },
    // Stats
    stats: {
      title: "Kauz Logistik - A Strong Partner",
      customers: "Satisfied Customers",
      experience: "Years Experience",
      warehouse: "m² Warehouse Space",
      packages: "Packages per Year",
    },
    // CTA
    cta: {
      title: "We're Happy to Advise You",
      description: "Request your individual and non-binding quote now and turbocharge your business with us!",
      button: "Contact Us!",
    },
    // Blog
    blog: {
      title: "Blog Posts",
      viewAll: "View All",
      readMore: "Read more",
    },
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "We look forward to hearing from you and will get back to you as soon as possible.",
      reachUs: "How to Reach Us",
      phone: "Phone",
      email: "Email",
      address: "Address",
      hours: "Business Hours",
      hoursValue: "Mon-Fri: 08:00 - 17:00",
      companyData: "Company Information",
      writeUs: "Write to Us",
      formDescription: "Fill out the form and we will get back to you as soon as possible.",
      name: "Name",
      company: "Company",
      message: "Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Thank You!",
      successMessage: "Your message has been sent successfully. We will get back to you as soon as possible.",
      sendAnother: "Send Another Message",
    },
    // Quote
    quote: {
      title: "Request a Quote",
      subtitle: "Request your individual and non-binding quote now.",
      ourServices: "Our Services",
      selectService: "Select the desired service and we will create a customized offer for you.",
      yourRequest: "Your Request",
      formDescription: "Fill out the form and we will create an individual offer for you.",
      contactPerson: "Contact Person",
      service: "Desired Service",
      selectServicePlaceholder: "Select service",
      volume: "Expected Volume",
      selectVolume: "Select volume",
      requirements: "Description of Your Requirements",
      requirementsPlaceholder: "Describe your requirements, e.g. type of goods, delivery areas, special requests...",
      submit: "Request Quote",
      benefits: "Your Benefits",
      free: "Free & Non-binding",
      fast: "Quick Response",
      individual: "Individual Consultation",
      transparent: "Transparent Pricing",
      success: "Thank You for Your Request!",
      successMessage: "We have received your quote request and will get back to you as soon as possible.",
      responseTime: "You will usually receive a response within 24 hours.",
      sendAnother: "Submit Another Request",
      combination: "Combination of Services",
    },
    // Footer
    footer: {
      description: "Your reliable partner for fulfillment, transport and packaging services in Sulzbach and the entire Rhine-Main region.",
      quickLinks: "Quick Links",
      home: "Home",
      servicesLink: "Services",
      companyLink: "Company",
      blogLink: "Blog",
      contactLink: "Contact",
      servicesTitle: "Services",
      contactTitle: "Contact",
      copyright: "All rights reserved.",
      ceo: "CEO",
      imprint: "Imprint",
      privacy: "Privacy Policy",
    },
    // Common
    common: {
      requestQuote: "Request Quote",
      contactUs: "Contact Us",
      phone: "Phone",
      email: "Email",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('language') || 'de';
    }
    return 'de';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
